import { createContext } from 'react'

import { type ShortcutProviderContextInterface } from './types'

export const ShortcutProviderContext = createContext<
  ShortcutProviderContextInterface | undefined
>(undefined)
